import { Button } from '@/Components/ui/button';
import { Link } from '@inertiajs/react';
import { X, Zap } from 'lucide-react';

interface DebugToolsHeaderProps {
    isSticky?: boolean;
}

export function DebugToolsHeader({ isSticky = true }: DebugToolsHeaderProps) {
    return (
        <header
            className={
                isSticky
                    ? 'sticky top-0 z-50 border-b bg-white/80 backdrop-blur-sm'
                    : 'border-b bg-white'
            }
        >
            <div className="mx-auto max-w-7xl px-4 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="rounded-lg bg-gradient-to-br from-blue-600 to-purple-600 p-2">
                            <Zap className="h-6 w-6 text-white" />
                        </div>
                        <div>
                            <h1 className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-2xl font-bold text-transparent">
                                <Link href="/">DebugTools.dev</Link>
                            </h1>
                            <p className="text-sm text-muted-foreground">
                                Developer debugging utilities
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <a
                            href="https://x.com/derrickleemy"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button variant="outline" size="sm">
                                <X className="h-4 w-4" />
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
}
